import React from 'react';
export var KONAMI_CODE = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a',
];
var areArraysEqual = function (arr1, arr2) { return arr1 === arr2 || (arr1.length === arr2.length && arr1.every(function (value, index) { return value === arr2[index]; })); };
var useKonami = function (_a) {
    var onUnlock = _a.onUnlock, _b = _a.sequence, inputSequence = _b === void 0 ? KONAMI_CODE : _b, onReset = _a.onReset, onKeyPress = _a.onKeyPress, inputTarget = _a.target;
    var index = React.useRef(0);
    var sequence = React.useRef(inputSequence);
    var mutableCallbacks = React.useRef({
        onUnlock: onUnlock,
        onReset: onReset,
        onKeyPress: onKeyPress,
    });
    mutableCallbacks.current = {
        onUnlock: onUnlock,
        onReset: onReset,
        onKeyPress: onKeyPress,
    };
    var keyHandler = React.useCallback(function (event) {
        var _a, _b, _c, _d;
        var key = event.key;
        if (key !== sequence.current[index.current]) {
            if (index.current !== 0) {
                (_b = (_a = mutableCallbacks.current).onReset) === null || _b === void 0 ? void 0 : _b.call(_a, index.current, event);
            }
            index.current = 0;
            return;
        }
        (_d = (_c = mutableCallbacks.current).onKeyPress) === null || _d === void 0 ? void 0 : _d.call(_c, key, index.current, event);
        index.current += 1;
        if (index.current === sequence.current.length) {
            mutableCallbacks.current.onUnlock(event);
            index.current = 0;
        }
    }, [mutableCallbacks]);
    var target = (inputTarget === undefined && typeof window !== 'undefined') ? window : inputTarget;
    React.useEffect(function () {
        var _a;
        (_a = target === null || target === void 0 ? void 0 : target.addEventListener) === null || _a === void 0 ? void 0 : _a.call(target, 'keydown', keyHandler);
        return function () {
            var _a;
            (_a = target === null || target === void 0 ? void 0 : target.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(target, 'keydown', keyHandler);
        };
    }, [target, keyHandler]);
    if (!areArraysEqual(inputSequence, sequence.current)) {
        // Input sequence changed, so reset current index
        sequence.current = inputSequence;
        index.current = 0;
    }
};
export default useKonami;
